import { createReducer } from '@ngrx/store';
import { on } from '@ngrx/store';
import { ActionReducer } from '@ngrx/store/src/models';
import { PublisherTimeZoneActions } from 'app/modules/main/store/publisher-time-zone/publisher-time-zone.actions';
import { PublisherTimeZoneState } from 'app/modules/main/store/publisher-time-zone/publisher-time-zone.state';

export class PublisherTimeZoneReducer {

  private static readonly initialState: PublisherTimeZoneState = {
    timeZone: '',
    timeZoneName: '',
    timeZoneLoaded: false,
  };

  private static readonly onPublisherTimeZoneLoaded = on(
    PublisherTimeZoneActions.$.publisherTimeZoneLoaded,
    (state: PublisherTimeZoneState, { timeZone }) =>
      ({
        ...state,
        ...timeZone,
        timeZoneLoaded: true,
      })
  );

  private static readonly onPublisherTimeZoneLoadFailed = on(
    PublisherTimeZoneActions.$.publisherTimeZoneLoadFailed,
    (_state: PublisherTimeZoneState) =>
      ({
        ...PublisherTimeZoneReducer.initialState,
        timeZoneLoaded: true,
      })
  );

  static reducer(): ActionReducer<PublisherTimeZoneState> {

    return <ActionReducer<PublisherTimeZoneState>>createReducer(
      PublisherTimeZoneReducer.initialState,
      PublisherTimeZoneReducer.onPublisherTimeZoneLoaded,
      PublisherTimeZoneReducer.onPublisherTimeZoneLoadFailed,
    );
  }

}
